module.exports = __webpack_public_path__ + "img/location.3e3b1f12.svg";